import { render, staticRenderFns } from "./CompareTable.vue?vue&type=template&id=55c8d895"
import script from "./CompareTable.vue?vue&type=script&lang=js"
export * from "./CompareTable.vue?vue&type=script&lang=js"
import style0 from "./CompareTable.vue?vue&type=style&index=0&id=55c8d895&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports